import bosses from '../../data/bosses'
import Boss from '../../models/Boss'



// initial state
const state = () => ({

})

// getters
const getters = {
    stats: () => {
        const bosses = Boss.all()
        const stats = {}
        stats.total = bosses.length
        stats.completed = bosses.filter((boss) => boss.completed).length
        stats.progress = Math.round(stats.completed / stats.total * 100)
        return stats
    },
    filtered: (state, getters, rootState) => {
        switch(rootState.configurations.filter) {
          case "completed":
            return Boss.query().where('completed', true).get()
          case "uncompleted":
            return Boss.query().where('completed', false).get()
          default:
            return Boss.query().all();
        }
    }
}

// actions
const actions = {
    load({ commit }) {
        commit('load', bosses)
    },
    complete({ commit }, boss) {
        commit('complete', { boss })
    },
    uncomplete({ commit }, boss) {
        commit('uncomplete', { boss })
    }
}

// mutations
const mutations = {
    load(state, bosses) {
        // Restore completed bosses
        bosses.forEach(boss => {
            if (Boss.query().where((persistedBoss) => { return persistedBoss.completed && persistedBoss.name == boss.name }).exists()) {
                boss.completed = true
            }
        });
        Boss.create({
            data: bosses
        })
    },
    complete(state, { boss }) {
        Boss.update({
            where: boss.name,
            data: {
                completed: true
            }
        })
    },
    uncomplete(state, { boss }) {
        Boss.update({
            where: boss.name,
            data: {
                completed: false
            }
        })
    }
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}